<template>
  <tr v-if="item.type === 0 ">
    <td
      class="group_res"
      @click="group_device('device_group/' + item.group_id)"
    >
      <span></span>
      <span class="group_name">{{ group_name.name }}({{ item.online }} / {{ item.count }})</span>
      <span class="client" v-if="group_name.client_name">{{ translate('client.one') + ': ' + group_name.client_name }}</span>
      <span v-else></span>
    </td>
  </tr>
  <tr v-else-if="item.type ===-1">
    <td class="group_res">
      {{ translate('no_result') }}
    </td>
  </tr>
  <router-link v-else :to="go_to()" >
    <tr ref="device_item" class="link">
      <td v-if="checkbox"
        class="checkbox_table"
        :data-label="translate('checkit')"
      >
        <input
          v-model="item.checked"
          type="checkbox"
          @click.stop="check"
        >
      </td>
      <td
        :data-label="translate('status')"
        class="status"
      >
        <div class="status__wrap">
          <span
            v-if="item.status"
            class="mdi mdi-access-point problem_device online" >
          </span>
          <span
            v-if="!item.status"
            class="mdi mdi-access-point-off problem_device offline" >
          </span>
          <span
            v-if="backup"
            class="mdi mdi-server-network problem_device backup"
          />
          <span
            v-if="blocked"
            class="mdi mdi-lock-alert problem_device blocked"
          />
        </div>

      </td>
      <td :data-label="translate('device.name')">
        <span v-html="device_name"/>
      </td>

      <!-- Скрывать если смотрим на страницу с мобилки -->

      <td :data-label="translate('device.simcards')" class="sim_status" v-if="!mobile_version">
        <p
          v-for="(simcard,key) in this.item.simcards_uptime"
          :key="key"
          class="simcard"
        >
          <span class="simcard_info" :style=" simcard.status? 'background-color: ' + simcard.status: 'background-color: #000'"></span>
          <span class="simcard_mno">{{ simcard.mno }} </span>
          <span v-if="simcard.slot" class="simcard_slot">({{ simcard.slot }})</span>
            <!-- <span class="simcard_imsi">{{ simcard.imsi }}</span> -->
        </p>
      </td>
      <td :data-label="translate('device.place')" v-if="!mobile_version">
        {{ item.place }}
      </td>
      <td :data-label="translate('device.desc')" v-if="!mobile_version">
        {{ item.desc }}
      </td>
      <td :data-label="translate('IP')" v-if="!mobile_version">
        <div
          class="response_table"
          style="height: 60px"
        >
          <table>
            <tbody>
              <tr
                v-for="(server,key) in item.servers"
                :key="key"
              >
                <td
                  class="cstm_ellipsis"
                  :title="server.name"
                >
                  {{ server.name }}
                </td><td
                  class="cstm_ellipsis"
                  :title="server.ip"
                >
                  {{ server.ip }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </td>
      <td data-label="Uptime" ref="uptime" v-if="!mobile_version">
        <router-link class='link' :to="{ path: '/device/' + item.fid + '/stats?&period=86400' }">

            <device-timeline-chart
                :trig_resize="resize"
                :chart-status="chartStatus"
                :item="item"
                :parent_width="parent_width()"
            />

        </router-link>
      </td>

    </tr>
  </router-link>
</template>
<script>
import SisIconStatus from 'components/UIComponents/Icon/SisIconStatus.vue'
import DeviceTimelineChart from './DeviceTimelineChart.vue'

export default {
  name: 'DeviceItem',
  components: {
    DeviceTimelineChart,
    SisIconStatus
  },
  props: {
    item: Object,
    index: [Number, String],
    checkbox: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      status: false,
      chartStatus: false,
      resize: false
    }
  },
  computed: {
    mobile_version(){
      return document.body.clientWidth < 768
    },
    device_name () {
      let name = "ID: " + this.item.fid +'<br>'+ this.item.name2
      if (this.$store.getters.getPermissions.permissionGod) {
        name += '<br>'
        name += this.item.name
      }
      return name
    },
    group_name () {
      return this.$store.getters.getDeviceGroupById(this.item.id)
    },
    blocked () {
      return this.item?.blocked_status === 1
    },
    backup () {
      if (this.item.backup) {
        return this.item.backup_serv + ':' + this.item.backup_ip
      }
      return false
    },
  },
  activated () {
    this.$emit('mount', this.index)
  },
  mounted () {
    this.$emit('mount', this.index)
  },
  methods: {
    parent_width(){
      return this.$refs.uptime ? this.$refs.uptime.clientWidth : 100
    },
    group_device(url){
      this.$router.push(url)
    },
    link_sim(link){
      this.$router.push(link)
    },
    check () {
      this.$emit('check', !this.item.checked, this.item)
    },
    cntx_menu (e) {
      this.$emit('contextmenu', e, this.item)
    },
    go_to () {
      return {path: '/device/' + this.item.fid.trim()}
    },
    ready () {
      this.$emit('ready', this.index)
    }
  }
}
</script>

<style lang="scss" scoped>
  .link{
    margin-top: -1px;
    vertical-align: middle;
    &:hover{
      background-color: #f1f1f1;
      color: black;
    }
  }
  .status{
    &__wrap{
      display: flex;
      align-items: center;
      justify-content: center;
      .problem_device {
        font-size: 22px;
        line-height: 100%;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        &.online{
          color: #15ab00
        }
        &.backup{
          color:#ffbb40
        }
        &.blocked{
          color:#ff4040
        }
      }
    }
  }

  .group_res{
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    span{
      min-width: 250px;
    }
    .client{
      text-align: right;
    }
    &:hover{
      background-color: #d5d5d5
    }
  }
  .sim_status{
    width: 150px;
    .simcard{
      font-size: 10px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 0;
      &_info{
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-right: 5px;
      }
      &_mno{
        margin-right: 5px;
      }
    }
  }


</style>
